import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import DesignKitchen from "./DesignKitchen.jsx";
import DnesPreview from "./DnesPreview.jsx";
import "./styles.css";
import "./tokens.css";

// v26.2 §2 — mark Android so CSS/JS can drop backdrop-filter (Mali/Chrome compositing bug).
if (typeof navigator !== "undefined" && /Android/i.test(navigator.userAgent))
  document.documentElement.classList.add("android");

// Dev-only previews: #kitchen = primitive gallery, #dnes = new Dnes mock.
const h = window.location.hash;
const Root = h === "#kitchen" ? DesignKitchen : h === "#dnes" ? DnesPreview : App;

ReactDOM.createRoot(document.getElementById("root")!).render(<Root />);
